import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ArrowLeft, Shield, Bell } from 'lucide-react';
import Sidebar from './Sidebar';
import UserDropdown from './UserDropdown';
import SecuritySettings from './SecuritySettings';
import ForgotPasswordSettings from './ForgotPasswordSettings';
import ReminderSettings from './ReminderSettings';

const TABS = [
  { key: 'security', label: 'Security', icon: Shield, description: 'Sign-in and password recovery security for all users.' },
  { key: 'reminders', label: 'Invoice Reminders', icon: Bell, description: 'Daily internal reminder emails for recurring/proforma invoices approaching or past their due date.' }
];

// Admin -> Settings. The active tab lives in the URL (?tab=) so it survives
// a refresh and can be linked to.
const Settings = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const active = TABS.find((t) => t.key === searchParams.get('tab')) || TABS[0];

  return (
    <div className="main-container" style={{ display: 'flex', minHeight: '100vh', backgroundColor: '#f8fafc' }}>
      <Sidebar />

      <div className="main-content" style={{ flex: 1, padding: '2rem', minWidth: 0 }}>
        <div className="header-section" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }}>
              <button
                onClick={() => navigate('/dashboard')}
                aria-label="Back to dashboard"
                style={{ display: 'flex', alignItems: 'center', padding: '0.5rem', border: 'none', backgroundColor: 'transparent', color: '#6b7280', cursor: 'pointer', marginRight: '1rem' }}
              >
                <ArrowLeft size={20} />
              </button>
              <h2 style={{ fontSize: '2rem', fontWeight: 'bold', color: '#1f2937' }}>Settings</h2>
            </div>
            <p style={{ color: '#6b7280' }}>{active.description}</p>
          </div>
          <div className="user-dropdown">
            <UserDropdown />
          </div>
        </div>

        <div role="tablist" style={{ display: 'flex', gap: '0.25rem', borderBottom: '1px solid #e5e7eb', marginBottom: '1.5rem', overflowX: 'auto' }}>
          {TABS.map((tab) => {
            const Icon = tab.icon;
            const isActive = tab.key === active.key;
            return (
              <button
                key={tab.key}
                role="tab"
                aria-selected={isActive}
                onClick={() => setSearchParams({ tab: tab.key })}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  padding: '0.75rem 1rem',
                  border: 'none',
                  borderBottom: `2px solid ${isActive ? '#3b82f6' : 'transparent'}`,
                  marginBottom: '-1px',
                  backgroundColor: 'transparent',
                  color: isActive ? '#1d4ed8' : '#6b7280',
                  fontSize: '0.875rem',
                  fontWeight: 500,
                  cursor: 'pointer',
                  whiteSpace: 'nowrap'
                }}
              >
                <Icon size={16} />
                {tab.label}
              </button>
            );
          })}
        </div>

        {active.key === 'security' ? (
          <>
            <SecuritySettings />
            <ForgotPasswordSettings />
          </>
        ) : (
          <ReminderSettings embedded />
        )}
      </div>
    </div>
  );
};

export default Settings;
